import React from 'react';
import AuctionIntroTour from './AuctionIntroTour';

export default function AutionIntroTour2({dataTour = [], handleSkip = () => {}}) {
  return (
    <AuctionIntroTour dataTour = {dataTour} handleSkip = {handleSkip} />
  )
}
